import { render, staticRenderFns } from "./CustomDocumentEditorPanel.vue?vue&type=template&id=44bd8fee&scoped=true&"
import script from "./CustomDocumentEditorPanel.vue?vue&type=script&lang=ts&"
export * from "./CustomDocumentEditorPanel.vue?vue&type=script&lang=ts&"
import style0 from "./CustomDocumentEditorPanel.vue?vue&type=style&index=0&id=44bd8fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd8fee",
  null
  
)

export default component.exports